angular.module('dpw.components')

    .directive('dpwDirtyFormCheck', ['$window', 'appProfileUtils', function ($window, appProfileUtils) {
        var isDirtyCheckNeeded = function (next, current) {
            return next && next.dirtyFormCheck !== false &&
                current && current.dirtyFormCheck !== false;
        };

        var isDirtyFormDetected = function () {
            var detected = false;

            // TODO: Add or remove a form for the dirty check mechanism.
            RCDPW.isAppSettingFormDirty && (detected = true);
            appProfileUtils.isProfileFormDirty() && (detected = true);
            RCDPW.isEditProfileFormDirty && (detected = true);
            RCDPW.isBotNameFormDirty && (detected = true);
            RCDPW.isBotWebhookFormDirty && (detected = true);
            RCDPW.isAppEditFormDirty && (detected = true);

            return detected;
        };

        var resetDirtyFormStatus = function () {
            // TODO: Add or remove a form for the dirty check mechanism.
            RCDPW.isAppSettingFormDirty = false;
            appProfileUtils.setProfileFormDirty(false);
            RCDPW.isEditProfileFormDirty = false;
            RCDPW.isBotNameFormDirty = false;
            RCDPW.isBotWebhookFormDirty = false;
            RCDPW.isAppEditFormDirty = false;
        };

        return {
            restrict: 'A',
            controller: ['$scope', '$location', 'popup', function ($scope, $location, popup) {
                var needDirtyFormCheck = true;
                var dirtyCheckPopupShow = false;

                $scope.$on('$routeChangeStart', function (e, next, current) {
                    if (dirtyCheckPopupShow) {
                        e.preventDefault();
                        return;
                    }

                    needDirtyFormCheck = isDirtyCheckNeeded(next, current);

                    if (needDirtyFormCheck && isDirtyFormDetected()) {

                        // DPW-2100, can't use confirm
                        // confirm(msg) ? (RCDPW.isAppSettingFormDirty = false) : e.preventDefault();

                        e.preventDefault();
                        dirtyFormConfirm({newRoute: next});
                    }
                });

                $scope.$on('dirtyFormCheck:performCheck', function (e, onLeave, onStay) {
                    if (isDirtyFormDetected()) {
                        e.preventDefault();
                        dirtyFormConfirm({
                            onLeave: onLeave,
                            onStay: onStay
                        });

                        return;
                    }

                    _.isFunction(onLeave) && onLeave();
                });

                function dirtyFormConfirm(options) {
                    options = options || {};

                    var noticeScope = $scope.$new();
                    noticeScope.callback = callback;
                    onPopupShow();

                    noticeScope.$on('popupDestroy', onPopupClose);
                    popup({
                        scope: noticeScope,
                        directiveName: 'dpw-dirty-form-confirm',
                        extraClass: [
                            'popup-auto-width console-ui popup-top',
                            RCDPW.isAdminSite ? 'admin' : 'my-account'
                        ].join(' ')
                    });

                    function callback(leavingPage) {
                        onPopupClose();
                        noticeScope.$destroy();

                        if (leavingPage) {
                            leavePage();
                        } else {
                            stayAtPage();
                        }
                    }

                    function leavePage() {
                        resetDirtyFormStatus();

                        var newRoute = options.newRoute;
                        var onLeave = options.onLeave;

                        if (newRoute) {
                            var path;

                            try {
                                path = newRoute.originalPath.replace(":id", newRoute.pathParams.id);
                            } catch (err) {
                                path = newRoute.redirectTo;
                            }

                            $location.path(path);

                            return;
                        }

                        _.isFunction(onLeave) && onLeave();
                    }

                    function stayAtPage() {
                        _.isFunction(options.onStay) && options.onStay();
                    }
                }

                function onPopupClose() {
                    dirtyCheckPopupShow = false;
                }

                function onPopupShow() {
                    dirtyCheckPopupShow = true;
                }
            }],

            link: function () {
                var message = RCDPW.Lang.DIRTY_FORM_NOT_SAVED;

                $window.onbeforeunload = function (e) {
                    e = e || window.event;

                    if (RCDPW.isLogingOut !== true && isDirtyFormDetected()) {
                        e && (e.returnValue = message);
                        return message;
                    }
                };
            }
        };
    }])

    .directive('dpwDirtyFormConfirm', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', function ($scope) {
                var self = this;

                self.yes = function () {
                    $scope.callback(true);
                };

                self.no = function () {
                    $scope.callback(false);
                };
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-dirty-form-confirm.html'
        };
    }])

;
